<template>
    <div class="private-class">
        <div class="private-class-banner">
            <div class="private-class-banner-img-cover">
            </div>
            <div class="private-class-banner-title">
                Private Class
            </div>
            <div class="private-class-banner-suggestion-and-question">
                The ultimate structured, comprehensive, easy classes
            </div>
            <div class="private-class-banner-description">
                Having one-to-one Private online class with our teacher through Zoom Meeting.
                <br>
                We prepare Your Private class content and materials according to your needs and your level to have a best outcome result!
            </div>
        </div>
        <div class="private-class-categories">
            <div class="private-class-categories-logo">
                <img class="private-class-categories-logo-pc" src="../assets/img/ata-line.png">
                <img class="private-class-categories-logo-mobile" src="../assets/img/mobile/ata-line.png">
            </div>
            <div class="private-class-title">
                We prepare Your Private class content according to your needs and your level to have a best result.
            </div>
            <div class="private-class-list">
                <div class="private-class-nav">
                    <img class="pc" src="../assets/img/pc-bg01.png">
                    <img class="mobile" src="../assets/img/mobile/pc-bg01-mobile.png">
                    <span class="nav-name">
                        Medical Chinese class with teacher ANNA (pay)
                    </span>
                </div>
                <div class="private-class-nav">
                    <img class="pc" src="../assets/img/pc-bg02.png">
                    <img class="mobile" src="../assets/img/mobile/pc-bg02-mobile.png">
                    <span class="nav-name">
                        Business Chinese class with teacher ANNA
                    </span>
                </div>
                <div class="private-class-nav">
                    <img class="pc" src="../assets/img/pc-bg03.png">
                    <img class="mobile" src="../assets/img/mobile/pc-bg03-mobile.png">
                    <span class="nav-name">
                        Basic Chinese class/ HSK 1-3 with our teachers.
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PrivateClass',
        data() {
            return {

            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

            }
        }
    }
</script>
<style lang='scss' type='text/css'>
    @import "../styles/pc/PrivateClass.scss";
    @import "../styles/mobile/PrivateClass.scss";
</style>